var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgChatBubble24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.339 16.504a1 1 0 0 1 .08.856l-.716 1.959 1.97-.72a1 1 0 0 1 .85.078l.408.24a7.984 7.984 0 0 0 4.068 1.104 8.03 8.03 0 1 0-8.03-8.03c0 1.504.411 2.905 1.126 4.105l.244.408Zm-2.195.202c.141.265.174.578.07.86l-.759 2.077c-.438 1.198.726 2.362 1.924 1.924l2.093-.765c.281-.103.592-.072.856.068A9.987 9.987 0 0 0 12 22.02c5.54 0 10.03-4.49 10.03-10.03 0-5.54-4.49-10.03-10.03-10.03-5.54 0-10.03 4.49-10.03 10.03 0 1.704.425 3.31 1.175 4.715Z",
    clipRule: "evenodd"
  })));
});
SvgChatBubble24.displayName = "SvgChatBubble24";
export default SvgChatBubble24;